import React from 'react'
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"

export default class BedroomPresenterGeneral extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        <div className="row">
          <div className="col-md-7">
            {this.renderGeneralData()}
          </div>
        </div>
      </div>
    )
  }

  renderGeneralData() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-2">
            <div className="form-group" style= {{width: "130px"}} >
              <label>{`${I18n.t('code')}*`}</label>
              <div>{this.props.code}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-5">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <div>{this.props.name}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>{I18n.t('description')}</label>
                <div dangerouslySetInnerHTML={{__html: this.props.description}}></div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-5">
            <div className="form-group">
              <label>
                {I18n.t('room_size')} <span className="ss-help help" title={I18n.t('room_size_helper_text')}></span>
              </label>
              <div>{this.props.room_size}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-5">
            <div className="form-group">
              <label>
                {I18n.t('bed_type')} <span className="ss-help help" title={I18n.t('bed_type_helper_text')}></span>
              </label>
              <div>{this.props.bed_type}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };
};
